import { format } from 'url';
import { HubIntegrationsManifest } from '@logz-pkg/models';
import { ICrudApiService } from '../utilities/types';
import { CrudApiService } from '../utilities/crud.api.service';

class IntegrationsHubService implements ICrudApiService<HubIntegrationsManifest> {
  manifestApiService = new CrudApiService({ modelDefinition: HubIntegrationsManifest });
  urls = {
    manifest: () =>
      format({
        pathname: '/integrations/manifest',
      }),
  };

  getManifest = (): Promise<HubIntegrationsManifest> => this.manifestApiService.get(this.urls.manifest());
}

export const integrationsHubService = new IntegrationsHubService();
